let installed = false;
let warned = false;

const moved = () => {
  if (!warned) console.warn('A DOM node React expected was moved, most likely by page translation.');
  warned = true;
};

/**
 * Where a page translator has swapped out a node React still references, skips the removal and appends the
 * insert, instead of throwing and unmounting the whole tree (it took a Stripe form down mid-payment).
 */
export const initDomFallback = () => {
  if (installed || typeof Node !== 'function') return;
  installed = true;

  const { removeChild, insertBefore } = Node.prototype;

  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode === this) return removeChild.call(this, child) as T;
    moved();
    return child;
  };

  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, reference: Node | null): T {
    if (reference && reference.parentNode !== this) {
      moved();
      reference = null;
    }
    return insertBefore.call(this, node, reference) as T;
  };
};
